import { defineComponent, ref, computed, inject } from 'vue';
import { useLocalizationSupport } from '../../composables/localization-support/index.js';

var _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "UiCursorPagination",
  props: {
    locale: { type: null, required: true },
    next: { type: String, required: false },
    previous: { type: String, required: false },
    disabled: { type: Boolean, required: false, default: false }
  },
  emits: ["input"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const activePageOffset = ref(0);
    const displayPagination = computed(() => {
      return !!props.next || !!props.previous || activePageOffset.value > 0;
    });
    const isPreviousActive = computed(() => {
      return activePageOffset.value > 0;
    });
    const onClickPaginationFirst = () => {
      if (activePageOffset.value > 0) {
        activePageOffset.value = 0;
        emits("input", null);
      }
    };
    const onClickPaginationPrevious = () => {
      if (activePageOffset.value > 0) {
        activePageOffset.value--;
        emits("input", activePageOffset.value === 0 ? null : props.previous);
      }
    };
    const onClickPaginationNext = () => {
      activePageOffset.value++;
      emits("input", props.next);
    };
    const localizationSupport = useLocalizationSupport(props, { translator: inject("translator") });
    const { translate } = localizationSupport;
    return { __sfc: true, props, emits, activePageOffset, displayPagination, isPreviousActive, onClickPaginationFirst, onClickPaginationPrevious, onClickPaginationNext, localizationSupport, translate };
  }
});

export { _sfc_main as default };
